/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Glad_Flat_Heron_PurrInputs */

const en_glad_flat_heron_purr = /** @type {(inputs: Glad_Flat_Heron_PurrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result`)
};

const de_glad_flat_heron_purr = /** @type {(inputs: Glad_Flat_Heron_PurrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnis`)
};

/**
* | output |
* | --- |
* | "Result" |
*
* @param {Glad_Flat_Heron_PurrInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const glad_flat_heron_purr = /** @type {((inputs?: Glad_Flat_Heron_PurrInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Glad_Flat_Heron_PurrInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_glad_flat_heron_purr(inputs)
	return de_glad_flat_heron_purr(inputs)
});